var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.806 82.117a33.442 33.442 0 0 1-9.201 1.283c-18.416 0-33.399-14.983-33.399-33.4 0-8.432 3.079-16.319 8.704-22.475v11.971a1.5 1.5 0 1 0 3 0V23.345a1.5 1.5 0 0 0-1.5-1.5H12.26a1.5 1.5 0 1 0 0 3h13.037c-6.52 6.8-10.092 15.664-10.092 25.155 0 20.071 16.329 36.4 36.399 36.4a36.5 36.5 0 0 0 10.025-1.398 1.5 1.5 0 1 0-.824-2.884Zm26.934-4.869H75.714C83.455 70.377 88.005 60.419 88.005 50c0-20.071-16.329-36.4-36.4-36.4-4.862 0-9.584.943-14.034 2.804a1.5 1.5 0 1 0 1.158 2.767 33.19 33.19 0 0 1 12.876-2.572c18.417 0 33.4 14.983 33.4 33.4 0 9.845-4.419 19.25-11.914 25.566V62.597a1.5 1.5 0 1 0-3 0v16.149a1.5 1.5 0 0 0 1.5 1.5H87.74a1.5 1.5 0 1 0 0-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.9d28091008425526452e35389391097c.svg";
export { ForwardRef as ReactComponent };